"use strict";

var _slicedToArray = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _taggedTemplateLiteral = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _QuestionContainer = require("../QuestionContainer");
var _QuestionContainer2 = _interopRequireDefault(_QuestionContainer);
var _styledComponents = require("styled-components");
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _QuestionText = require("../QuestionText");
var _QuestionText2 = _interopRequireDefault(_QuestionText);
var _Slider = require("@mui/material/Slider");
var _Slider2 = _interopRequireDefault(_Slider);
var _useQuestionAnswer = require("../../hooks/use-question-answer");
var _useQuestionAnswer2 = _interopRequireDefault(_useQuestionAnswer);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Row = _styledComponents2.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  padding-top: 10px;\n"])));
exports.default = function (_ref) {
  var question = _ref.question,
    onChangeAnswer = _ref.onChangeAnswer;
  var _ref2 = (0, _useQuestionAnswer2.default)(question, onChangeAnswer, question.defaultAnswer || undefined),
    _ref3 = _slicedToArray(_ref2, 2),
    _ref3$ = _ref3[0],
    answer = _ref3$.answer,
    error = _ref3$.error,
    changeAnswer = _ref3[1];
  var rateValues = question.rateValues,
    rankings = question.rankings,
    minRateDescription = question.minRateDescription,
    maxRateDescription = question.maxRateDescription,
    midRateDescription = question.midRateDescription;
  return _react2.default.createElement(_QuestionContainer2.default, {
    question: question,
    answered: answer !== undefined,
    error: error
  }, _react2.default.createElement(_Slider2.default, {
    onChange: function onChange(e, value) {
      return changeAnswer(value);
    },
    style: {
      opacity: answer === undefined ? 0.5 : 1,
      marginTop: 10
    },
    value: answer === undefined ? rateValues ? rateValues[Math.floor(rateValues.length / 2)] : 2 : answer,
    min: 0,
    max: rankings - 1 || rateValues ? rateValues[rateValues.length - 1] : 4,
    step: 1,
    id: question.id ? question.id + "Slider" : ""
  }), rateValues ? _react2.default.createElement(Row, null, rateValues.map(function (r) {
    return _react2.default.createElement(_QuestionText2.default, {
      key: r
    }, r);
  })) : _react2.default.createElement(Row, null, _react2.default.createElement(_QuestionText2.default, null, minRateDescription), midRateDescription && _react2.default.createElement(_QuestionText2.default, null, midRateDescription), _react2.default.createElement(_QuestionText2.default, null, maxRateDescription)));
};